import TrendForm from "./TrendForm";

export default TrendForm;
